<form class="horizontal-form" [formGroup]="form" (ngSubmit)="submit()">
  <div class="modal-header">
    <h4 class="modal-title pull-left">New Domain</h4>
    <button
      type="button"
      class="btn-close pull-right"
      aria-label="Close"
      (click)="closeModal()"
      (keydown.enter)="closeModal()"></button>
  </div>
  <div class="modal-body">
    @if (showFormInvalid()) {
      <div class="alert alert-danger" role="alert">
        <i class="fa fa-lg fa-warning"></i>
        {{
          form.errors.global || 'An error occurred after submitting the form.'
        }}
      </div>
    }
    @if (form.errors?.uniqueness) {
      <div class="alert alert-danger" role="alert">
        <i class="fa fa-lg fa-warning"></i>This code is already in use.
      </div>
    }
    <div class="mb-3 row">
      <label for="parent" class="col-md-2 col-form-label">Parent domain</label>
      <div class="col">
        <domain-selector
          class="form-control-holder"
          [ngClass]="showFieldInvalid('parent') ? 'is-invalid' : ''"
          [formGroup]="form"
          [formControlName]="'parent'"
          [placeholder]="'Select parent domain'"
          [allowNewDomain]="true"></domain-selector>
        <div class="invalid-feedback">Please select a parent domain.</div>
      </div>
    </div>
    <div class="mb-3 row">
      <label for="name" class="col-md-2 col-form-label">Name</label>
      <div class="col">
        <input
          type="text"
          class="form-control"
          placeholder="Descriptive name"
          [class.is-invalid]="showFieldInvalid('name')"
          formControlName="name"
          required />
        <div class="invalid-feedback">Please enter a domain name.</div>
      </div>
    </div>
    <div class="mb-3 row">
      <label for="code" class="col-md-2 col-form-label">Domain code</label>
      <div class="col">
        <input
          type="text"
          class="col-md form-control"
          placeholder="Unique identifier e.g. DOMAIN"
          [ngClass]="showFieldInvalid('code') ? 'is-invalid' : ''"
          formControlName="code"
          required />
        <div class="invalid-feedback">
          @if (code.errors?.required) {
            Please enter a domain code.
          }
          @if (code.errors?.pattern) {
            Domain code may contain only alphanumeric characters and special
            characters _ . -
          }
          @if (code.errors?.uniqueness) {
            This domain code is already used.
          }
        </div>
      </div>
    </div>
    <div class="mb-3 row">
      <label for="externalId" class="col-md-2 col-form-label"
        >External identifier</label
      >
      <div class="col">
        <input
          type="text"
          class="col form-control"
          placeholder="(Optional) External identifier e.g. EX-123456"
          formControlName="externalId" />
      </div>
    </div>
    <div class="mb-3 row">
      <label class="col-md-2 col-form-label">Create TMS contract</label>
      <div class="col">
        <label class="switch switch-3d switch-primary">
          <input
            type="checkbox"
            class="switch-input"
            formControlName="createTmsContract" />
          <span class="switch-label"></span>
          <span class="switch-handle"></span>
        </label>
      </div>
    </div>
    <div class="mb-3 row">
      <label for="externalId" class="col-md-2 col-form-label"
        >Create User</label
      >
      <div class="col">
        <label class="switch switch-3d switch-primary">
          <input
            type="checkbox"
            class="switch-input"
            formControlName="createUser" />
          <span class="switch-label"></span>
          <span class="switch-handle"></span>
        </label>
      </div>
    </div>
    <div class="mb-3 row" [hidden]="!form.get('createUser').value">
      <div class="col offset-1">
        <app-new-user
          [config]="{
            showButtons: false,
            showContainer: false,
            showDomainInput: false,
            showSendPasswordEmail: true,
          }"></app-new-user>
      </div>
    </div>
  </div>
  @if (loading$ | async) {
    <loader-line></loader-line>
  }
  <div class="modal-footer">
    <div class="form-submit">
      <button
        type="submit"
        class="btn btn-primary"
        [disabled]="
          form.invalid ||
          submitting ||
          !(
            !form.get('createUser').value ||
            (form.get('createUser').value && newUserComponent?.form.valid)
          )
        ">
        <i class="fa fa-check"></i> Create
      </button>
      <button
        type="button"
        class="btn btn-secondary"
        (click)="reset()"
        (keydown.enter)="reset()">
        <i class="fa fa-ban"></i> Reset
      </button>
    </div>
  </div>
</form>
